document.addEventListener('DOMContentLoaded', function() {
    const playerElement = document.querySelector('.player');
    const iframeContainer = document.querySelector('.iframe');

    if (playerElement && iframeContainer) {
        playerElement.addEventListener('click', function() {
            const iframeElement = document.createElement('iframe');
            iframeElement.classList.add('video-yt');
            iframeElement.src = 'https://www.youtube.com/embed/' + playerElement.dataset.videoId + '?autoplay=1';
            iframeElement.title = 'Video MGConex';
            iframeElement.frameBorder = '0';
            iframeElement.allow = 'autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframeElement.referrerPolicy = 'strict-origin-when-cross-origin';
            iframeElement.allowFullscreen = true;
            playerElement.classList.add('fade-out');
            iframeContainer.style.display = 'block';
            iframeContainer.classList.add('fade-in');
            iframeContainer.appendChild(iframeElement);
            playerElement.addEventListener('animationend', function() {
                playerElement.style.display = 'none';
                playerElement.classList.remove('fade-out');
            }, { once: true });
            iframeContainer.addEventListener('animationend', function() {
                iframeContainer.classList.remove('fade-in');
            }, { once: true });
        });
    }
});
